import { AxiosInstance, AxiosRequestConfig } from 'axios';

export enum API_KEYS {
  LOGIN = 'LOGIN',
  SIGN_UP = 'SIGN_UP',
  EDIT_PROFILE = 'EDIT_PROFILE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  GET_WALLET_BALANCE = 'GET_WALLET_BALANCE',
  GET_STATIONS = 'GET_STATIONS',
  GET_ITEM_TYPES = 'GET_ITEM_TYPES',
  GET_ACTIVE_LGAS = 'GET_ACTIVE_LGAS',
  GET_SPECIAL_PACKAGES = 'GET_SPECIAL_PACKAGES',
  WALLET_TRANSACTIONS_SHIPMENT_HISTORY = 'WALLET_TRANSACTIONS_SHIPMENT_HISTORY',
  TRACK_SHIPMENT = 'TRACK_SHIPMENT',
  GET_HAULAGE = 'GET_HAULAGE',
  GET_HAULAGE_PRICE = 'GET_HAULAGE_PRICE',
  GET_SHIPMENT_DETAILS = 'GET_SHIPMENT_DETAILS',
  GET_DROPOFF = 'GET_DROPOFF',
  GET_OUTSTANDING_PAYMENTS = 'GET_OUTSTANDING_PAYMENTS',
  GET_SHIPMENT_IN_DISPUTE = 'GET_SHIPMENT_IN_DISPUTE',
  GET_PAYMENT_STATUS = 'GET_PAYMENT_STATUS',
  GET_HOME_DELIVERY_LOCATIONS = 'GET_HOME_DELIVERY_LOCATIONS',
  GET_SERVICE_CENTERS_BY_STATION = 'GET_SERVICE_CENTERS_BY_STATION',
  GET_STATIONS_BY_COUNTRY = 'GET_STATIONS_BY_COUNTRY',
  GET_SERVICE_CENTERS_BY_COUNTRY = 'GET_SERVICE_CENTERS_BY_COUNTRY',
  GET_IDENTIFICATION_TYPES = 'GET_IDENTIFICATION_TYPES',
  GET_ACTIVE_COUNTRIES = 'GET_ACTIVE_COUNTRIES',
  GET_SHIPMENT_MESSAGE = 'GET_SHIPMENT_MESSAGE',
  GET_NOTIFICATIONS = 'GET_NOTIFICATIONS',
  UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION',
  GET_STORES_BY_COUNTRY = 'GET_STORES_BY_COUNTRY',
  GET_INTERNATIONAL_SHIPMENTS = 'GET_INTERNATIONAL_SHIPMENTS',
  VERIFY_PAYMENT = 'VERIFY_PAYMENT',
  REPORT_ISSUES = 'REPORT_ISSUES',
  GET_PRICE = 'GET_PRICE',
  GET_PRICE_QUOTE = 'GET_PRICE_QUOTE',
  GET_INTL_PRICE = 'GET_INTL_PRICE',
  ADD_WAYBILL_PAYMENT_LOG = 'ADD_WAYBILL_PAYMENT_LOG',
  CREATE_SHIPMENT = 'CREATE_SHIPMENT',
  RESOLVE_DISPUTE = 'RESOLVE_DISPUTE',
  CANCEL_SHIPMENT = 'CANCEL_SHIPMENT',
  CANCEL_SHIPMENT_NOCHARGE = 'CANCEL_SHIPMENT_NOCHARGE',
  ADD_WALLET_PAYMENT_LOG = 'ADD_WALLET_PAYMENT_LOG',
  ADD_RATING = 'ADD_RATING',
  VERIFY_OTP = 'VERIFY_OTP',
  RESEND_OTP = 'RESEND_OTP',
  GET_DROPOFF_PRICE = 'GET_DROPOFF_PRICE',
  CREATE_DROPOFF = 'CREATE_DROPOFF',
  CANCEL_DROPOFF = 'CANCEL_DROPOFF',
  INTL_SHIPMENT_REQUEST_LIST = 'INTL_SHIPMENT_REQUEST_LIST',
  GET_DROP_OFF_LIST = 'GET_DROP_OFF_LIST',
  CREATE_INTL_SHIPMENT_REQUEST = 'CREATE_INTL_SHIPMENT_REQUEST',
  EDIT_INTL_SHIPMENT_REQUEST = 'EDIT_INTL_SHIPMENT_REQUEST',
  GET_INTL_SHIPMENT_MESSAGE = 'GET_INTL_SHIPMENT_MESSAGE',
  PROFILE_INTL_USER = 'PROFILE_INTL_USER',
  GET_VEHICLE_STATUS = 'GET_VEHICLE_STATUS',
  UPLOAD_IMAGE = 'UPLOAD_IMAGE',
  HANDLE_SHIPMENT = 'HANDLE_SHIPMENT',
  GET_PARTNER_DETAILS = 'GET_PARTNER_DETAILS',
  GET_DELIVERY_MANIFEST = 'GET_DELIVERY_MANIFEST',
  DELETE_SHIPMENT = 'DELETE_SHIPMENT',
  REQUEST_QUOTE = 'REQUEST_QUOTE',
  GET_CATEGORIES_BY_COUNTRY = 'GET_CATEGORIES_BY_COUNTRY',
  TICKETMAN_ACCESSTOKEN = 'TICKETMAN_ACCESSTOKEN',
  GET_BILLS_CATEGORY = 'GET_BILLS_CATEGORY',
  GET_BILLERS_BY_CATEGORY = 'GET_BILLERS_BY_CATEGORY',
  GET_BILLER_PAYMENT_ITEMS = 'GET_BILLER_PAYMENT_ITEMS',
  CUSTOMER_VALIDATION = 'CUSTOMER_VALIDATION',
  GET_PAYMENT_REFERENCE = 'GET_PAYMENT_REFERENCE',
  CHARGE_WALLET = 'CHARGE_WALLET',
  SEND_PAY_ADVICE = 'SEND_PAY_ADVICE',
  VERIFY_USER_PIN = 'VERIFY_USER_PIN',
  VALIDATE_PHONENUMBER = 'VALIDATE_PHONENUMBER',
  GET_WALLETPIN_STATUS = 'GET_WALLETPIN_STATUS',
  ADD_USER_PIN = 'ADD_USER_PIN',
  CHANGE_USER_PIN = 'CHANGE_USER_PIN',
  RESET_WALLET_PIN = 'RESET_WALLET_PIN',
  WALLETPIN_VERIFY_OTP = 'WALLETPIN_VERIFY_OTP',
  VALIDATE_BILLS_PAYMENT = 'VALIDATE_BILLS_PAYMENT',
  GET_OUTBOUND_COUNTRIES = 'GET_OUTBOUND_COUNTRIES',
  GET_INTERNATIONAL_SHIPMENTS_RATE = 'GET_INTERNATIONAL_SHIPMENTS_RATE',
  GET_COMPUTE_COUPON = 'GET_COMPUTE_COUPON',
  GET_PAYMENTMETHOD_BY_COUNTRY = 'GET_PAYMENTMETHOD_BY_COUNTRY',
  CHECK_CELLULANT_ENCRYPTION = 'CHECK_CELLULANT_ENCRYPTION',
  GET_CURRENCY_EQUIVALENT = 'GET_CURRENCY_EQUIVALENT',
  GET_INTL_SHIPMENT_QUOTE = 'GET_INTL_SHIPMENT_QUOTE',
  ALPHA_LOGIN = 'ALPHA_LOGIN',
  GET_ALPHA_PRODUCT = 'GET_ALPHA_PRODUCT',
  GET_ALPHA_STATIONS = 'GET_ALPHA_STATIONS',
  GET_ACTIVE_ALPHA_LOCATIONS = 'GET_ACTIVE_ALPHA_LOCATIONS',
  GET_ALPHA_HOMEDELIVERY = 'GET_ALPHA_HOMEDELIVERY',
  GET_ALPHA_PAYMENT_METHODS = 'GET_ALPHA_PAYMENT_METHODS',
  GET_ALPHA_SERVICE_CENTERS = 'GET_ALPHA_SERVICE_CENTERS',
  GET_ALPHA_PRICE = 'GET_ALPHA_PRICE',
  WITHDRAW_COD = 'WITHDRAW_COD',
  VALIDATE_BANK = 'VALIDATE_BANK',
  GET_COD_BANKS = 'GET_COD_BANKS',
  GET_COD_HISTORY = 'GET_COD_HISTORY',
  CHECK_USER_COD_EXIST = 'CHECK_USER_COD_EXIST',
  CREATE_STELLAS_ACCOUNT = 'CREATE_STELLAS_ACCOUNT',
  VALIDATE_BVN = 'VALIDATE_BVN',
  CHECK_BVN_EXIST = 'CHECK_BVN_EXIST',
  GET_STELLAS_DETAILS = 'GET_STELLAS_DETAILS',
  GET_COD_ACCOUNT_STATEMENT = 'GET_COD_ACCOUNT_STATEMENT',
  GET_PERSONAL_SHOPPING_LIST = 'GET_PERSONAL_SHOPPING_LIST',
  GET_PERSONAL_SHOPPING_RECEIVER = 'GET_PERSONAL_SHOPPING_RECEIVER',
  GET_PERSONAL_SHOPPING_INVOICE = 'GET_PERSONALSHOPPING_INVOICE',
  CREATE_PERSONAL_SHOPPING_ITEM = 'CREATE_PERSONAL_SHOPPING_ITEM',
  UPDATE_PERSONAL_SHOPPING_ITEM = 'UPDATE_PERSONAL_SHOPPING_ITEM',
  CHARGE_PERSONAL_SHOPPING_WALLET = 'CHARGE_PERSONAL_SHOPPING_WALLET',
  DELETE_PERSONAL_SHOPPING_ITEM = 'DELETE_PERSONAL_SHOPPING_ITEM',
  GENERATE_CHECKOUT_URL = 'GENERATE_CHECKOUT_URL',
  REGISTER_FOR_PROMO = 'REGISTER_FOR_PROMO',
}

export interface API_LIBRARY_OBJECT {
  instance: AxiosInstance;
  request: AxiosRequestConfig;
}

export type API_LIBRARY = {
  [x in API_KEYS]: API_LIBRARY_OBJECT;
};
